import styled from 'styled-components';

const StyledScreenWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
`;

export default StyledScreenWrapper;
